import _pickBy from 'lodash/pickBy'
import {
  _delete, _get, _head, _patch, _post, _save,
  getUrlQueryParameterFromObject,
} from 'frontcore/utils/communications/apiClient'
import { _saveBinary } from './apiClient'

const URL_BASE_DIAGNOSIS = 'diagnoses'
const URL_BASE_DIAGNOSIS_BRICKS_GRAPH = 'bricks-graph'
const URL_BASE_DIAGNOSIS_FUNCTIONS = 'diagnoses-functions'
const URL_BASE_DIAGNOSIS_FUNCTIONS_GRAPH = 'diagnoses-functions-graphs'
const URL_BASE_DIAGNOSIS_RADAR_GRAPH = 'diagnoses-radar-graphs'
const URL_BASE_DIAGNOSIS_PRIORITIES_GRAPH = 'diagnoses-priorities-graph'
const URL_BASE_DIAGNOSIS__NO_APPLIED_PRIORITIES_AND_FUNCTIONS_TABLE = 'diagnoses-no-applied-priorities-and-functions-table'
const URL_BASE_DIAGNOSIS_SELF_ASSESSMENT = 'self-assessments-in-diagnoses'
const URL_BASE_DIAGNOSIS_ACTION_PLAN = 'action-plan-template'
const URL_BASE_DIAGNOSIS_TEMPLATE = 'diagnoses-templates'
const URL_BASE_DIAGNOSIS_REQUIREMENTS = 'requirements'
const URL_BASE_DIAGNOSIS_LINK_REPORT = 'diagnoses-link-report'

const URL_BASE_FUNDAMENTALS_IN_SELF_ASSESSMENT = 'fundamentals-in-self-assessment'
export const URL_BASE_SELF_ASSESSMENT_APPROVAL_LOGIN = 'self-assessment-approval-login'
export const URL_BASE_CONSOLIDATED_REPORT_APPROVAL_LOGIN = 'consolidated-report-approval-login'

const URL_BASE_FUNDAMENTAL_TARGETS = 'fundamental-targets'
const URL_BASE_FUNDAMENTAL_TAGET_FACTORY = 'fundamental-target-factory'
const URL_BASE_CONSOLIDATED_REPORT = 'self-assessments-consolidated-report'
const URL_BASE_CONSOLIDATED_REPORT_FACTORY = 'consolidated-report-factory'
const URL_BASE_CONSOLIDATED_REPORT_DETAIL = 'consolidated-reports'
const URL_BASE_CONSOLIDATED_REPORT_JOB = 'consolidated-report-to-remote-jobs'
const URL_BASE_FUNDAMENTALS_IN_CONSOLIDATED_REPORT = 'fundamentals-in-consolidated-report'

export function getDiagnoses (parameters) {
  if (Array.isArray(parameters.auditors)) parameters.auditors = parameters.auditors.join(',')
  if (Array.isArray(parameters.auditors)) parameters.auditors = parameters.auditors.join(',')
  const nonEmptyParams = _pickBy(parameters)
  const queryParams = getUrlQueryParameterFromObject(nonEmptyParams)
  const url = queryParams ? `${URL_BASE_DIAGNOSIS}/?${queryParams}` : `${URL_BASE_DIAGNOSIS}/`
  if (parameters.format === 'excel') {
    return _saveBinary(url)
  }
  return _get(url)
}

export function getDiagnosisExpanded (id) {
  const url = `${URL_BASE_DIAGNOSIS}/${id}/?format=expanded`
  return _get(url)
}

export function getPendingDiagnoses (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `${URL_BASE_DIAGNOSIS}/?${queryParams}`
  return _get(url)
}

export function getDiagnosis (id) {
  const url = `${URL_BASE_DIAGNOSIS}/${id}/`
  return _get(url)
}

export function saveDiagnosis (data) {
  const url = `${URL_BASE_DIAGNOSIS}/`
  return _save(url, data, true)
}

export function deleteDiagnosis (id) {
  const url = `${URL_BASE_DIAGNOSIS}/${id}/`
  return _delete(url)
}

export function patchDiagnosis (diagnosisId, data) {
  const url = `${URL_BASE_DIAGNOSIS}/${diagnosisId}/`
  return _patch(url, data)
}

export function getDiagnosisTemplate (id) {
  const url = `${URL_BASE_DIAGNOSIS_TEMPLATE}/${id}/?format=expanded`
  return _get(url)
}

export function getActiveDiagnosisTemplate () {
  const url = `${URL_BASE_DIAGNOSIS_TEMPLATE}/?active=true&format=expanded`
  return _get(url)
}

export function getDiagnosisFunctions (id) {
  const url = `${URL_BASE_DIAGNOSIS_FUNCTIONS}/?template=${id}`
  return _get(url)
}

export function getDiagnosisRequirements (id) {
  const url = `${URL_BASE_DIAGNOSIS_REQUIREMENTS}/?template=${id}`
  return _get(url)
}

export function getDiagnosisBricksGraph (id, templateID) {
  const url = `${URL_BASE_DIAGNOSIS_BRICKS_GRAPH}/?diagnosis=${id}&template=${templateID}`
  return _get(url)
}

export function getDiagnosisFunctionsGraph (id, templateID) {
  const url = `${URL_BASE_DIAGNOSIS_FUNCTIONS_GRAPH}/?diagnosis=${id}&template=${templateID}`
  return _get(url)
}

export function getDiagnosisRadarGraph (id, templateID) {
  const url = `${URL_BASE_DIAGNOSIS_RADAR_GRAPH}/?diagnosis=${id}&template=${templateID}`
  return _get(url)
}

export function getDiagnosisPrioritiesGraph (id, templateID) {
  const url = `${URL_BASE_DIAGNOSIS_PRIORITIES_GRAPH}/?diagnosis=${id}&template=${templateID}`
  return _get(url)
}

export function getDiagnosisNoAppliedPrioritiesAndFunctionsTable (id, templateID) {
  const url = `${URL_BASE_DIAGNOSIS__NO_APPLIED_PRIORITIES_AND_FUNCTIONS_TABLE}/?diagnosis=${id}&template=${templateID}`
  return _get(url)
}

export function getSelfAssessmentsInDiagnosis (id, score = null) {
  let url = `${URL_BASE_DIAGNOSIS_SELF_ASSESSMENT}/?diagnosis=${id}`
  if (score !== null) {
    url += `&score=${score}`
  }
  return _get(url)
}

export function getDiagnosisActionPlan (id) {
  const url = `${URL_BASE_DIAGNOSIS_ACTION_PLAN}/?diagnosis=${id}`
  return _saveBinary(url)
}

export function getLinkReport (id) {
  const url = `${URL_BASE_DIAGNOSIS_LINK_REPORT}/?diagnosis=${id}`
  return _get(url)
}

export function patchFundamentalInSelfAssessment (id, data) {
  const url = `${URL_BASE_FUNDAMENTALS_IN_SELF_ASSESSMENT}/${id}/`
  return _patch(url, data)
}

export function getConsolidatedReport (plantID) {
  const url = `${URL_BASE_CONSOLIDATED_REPORT}/?plant=${plantID}`
  return _get(url)
}

export function getConsolidatedReportFactory (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `${URL_BASE_CONSOLIDATED_REPORT_FACTORY}/?${queryParams}`
  return _get(url)
}

export function saveConsolidatedReportFactory (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `${URL_BASE_CONSOLIDATED_REPORT_FACTORY}/?${queryParams}`
  return _post(url)
}

export function getConsolidatedReportDetail (id) {
  const url = `${URL_BASE_CONSOLIDATED_REPORT_DETAIL}/${id}/?format=detail_page`
  return _get(url)
}

export function patchConsolidatedReportJob (id, data) {
  const url = `${URL_BASE_CONSOLIDATED_REPORT_JOB}/${id}/`
  return _patch(url, data)
}

export function headConsolidatedReport (plantID) {
  const url = `${URL_BASE_CONSOLIDATED_REPORT}/?plant=${plantID}`
  return _head(url)
}

export function createConsolidatedReport (data) {
  const url = `${URL_BASE_CONSOLIDATED_REPORT_DETAIL}/`
  return _save(url, data, true)
}

export function deleteConsolidatedReport (id) {
  const url = `${URL_BASE_CONSOLIDATED_REPORT_DETAIL}/${id}/`
  return _delete(url)
}
export function patchFundamentalInConsolidatedReport (id, data) {
  const url = `${URL_BASE_FUNDAMENTALS_IN_CONSOLIDATED_REPORT}/${id}/`
  return _patch(url, data)
}

export function selfAssessmentApprovalLogin (parameters) {
  const url = `${URL_BASE_SELF_ASSESSMENT_APPROVAL_LOGIN}/`
  return _save(url, parameters, true)
}

export function getConsolidatedReports (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `${URL_BASE_CONSOLIDATED_REPORT_DETAIL}/?${queryParams}`
  return _get(url)
}

export function getFundamentalsTargetsFactory (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `${URL_BASE_FUNDAMENTAL_TAGET_FACTORY}/?${queryParams}`
  return _get(url)
}

export function saveFundamentalsTargetsFactory (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `${URL_BASE_FUNDAMENTAL_TAGET_FACTORY}/?${queryParams}`
  return _post(url)
}

export function getFundamentalTargetByMonth (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `${URL_BASE_FUNDAMENTAL_TARGETS}/?${queryParams}&format=detail_page`
  return _get(url)
}

export function patchFundamentalTarget (id, data) {
  const url = `${URL_BASE_FUNDAMENTAL_TARGETS}/${id}/`
  return _patch(url, data)
}

export function getConsolidatedReportInExcel (id) {
  const url = `${URL_BASE_CONSOLIDATED_REPORT_DETAIL}/?id=${id}&format=excel`
  return _saveBinary(url)
}
